import {
  CalendarDateDimension,
  FinancialRateDimension,
  frRccwSelectedDimension,
  StringsEnumDimension,
  StringsWithDataEnumDimension,
  TextDimension,
} from '@orus.eu/dimensions'
import { type FrRccwFormula, frRccwProductVersions } from '@orus.eu/product'

export const frRccwProductVersionDimension = new StringsEnumDimension({
  name: 'frRccwProductVersion',
  displayKeys: { name: 'dimension_name_fr_rccw_product_version' },
  values: frRccwProductVersions,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const frRccwFormulaDimension = new StringsWithDataEnumDimension({
  name: 'frRccwFormula',
  displayKeys: {
    name: 'dimension_name_fr_rccw_formula',
    hint: 'dimension_hint_fr_rccw_formula',
  },
  entries: [
    ['RC', { label: 'Économique' }],
    ['RCVI', { label: 'Confort' }],
    ['DTA', { label: 'Tous risques' }],
  ] as const satisfies [FrRccwFormula, { label: string }][],
  considerForDifferenceComputationInUi: { client: true, partner: true, platform: true },
  includeInTrackingMessages: true,
  inputLocking: {
    lockedInQuoteFor: {
      client: frRccwSelectedDimension,
    },
  },
} as const)

export const frRccwOverchargeRateDimension = new FinancialRateDimension({
  name: 'frRccwOverchargeRate',
  displayKeys: { name: 'dimension_name_fr_rccw_overcharge_rate' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: true,
  inputLocking: undefined,
  configuration: { min: 0, max: 10, step: 0.01 },
})

export const frRccwMinBirthDateDimension = new CalendarDateDimension({
  name: 'frRccwMinBirthDate',
  displayKeys: { name: 'dimension_name_fr_rccw_min_birth_date' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: false },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const frRccwMaxBirthDateDimension = new CalendarDateDimension({
  name: 'frRccwMaxBirthDate',
  displayKeys: { name: 'dimension_name_fr_rccw_max_birth_date' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: false },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const frRccwCustomSummaryDimension = new TextDimension({
  name: 'frRccwCustomSummary',
  displayKeys: { name: 'dimension_name_fr_rccw_custom_summary', hint: 'dimension_hint_fr_rccw_custom_summary' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
